import React from 'react'
import PropTypes from 'prop-types'
import ErrorComponent from 'components/ErrorComponent'

class UncaughtException extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  state = {}

  componentDidCatch(error, info) {
    if (process.env.REACT_APP_ACCOUNT_NODE_ENV !== 'local') {
      this.setState({ error, info }, () =>
        window.Raven.captureException(error, { extra: this.state.info }),
      )
    }
  }

  render() {
    if (this.state.error && process.env.REACT_APP_ACCOUNT_NODE_ENV !== 'local') {
      return (
        <ErrorComponent message='Caso o erro persista, entre em contato com o nosso suporte.' />
      )
    }

    return this.props.children
  }
}

export default UncaughtException
